import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export const createEditEmpresaHttp = async (data: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/createEditEmpresa"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getEmpresasHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getEmpresas`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const desactivarEmpresaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/desactivarEmpresa`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const activarEmpresaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/activarEmpresa`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
